import { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

const FileViewer = (props) => {
  const [loading, setLoading] = useState(true);
  const [FileViewerComponent, setFileViewerComponent] = useState(null);

  useEffect(() => {
    const loadFileViewer = () =>
      new Promise((resolve, reject) => {
        if (window.FileViewer) {
          resolve({ isSuccess: true, component: window.FileViewer });
        } else {
          const head = document.getElementsByTagName('head')[0];
          const script = document.createElement('script');

          script.setAttribute('type', 'text/javascript');

          // Use PUBLIC_URL or fallback to '/'
          const publicUrl = process.env.PUBLIC_URL || '';
          const scriptPath = publicUrl + '/lib/file.viewer.min.js';
          script.setAttribute('src', scriptPath);

          script.onload = () => {
            if (window.FileViewer) {
              resolve({ isSuccess: true, component: window.FileViewer });
            } else {
              reject({ error: 'FileViewer is not defined after script load!' });
            }
          };

          script.onerror = () => {
            reject({ error: 'Cannot load file viewer script!' });
          };

          head.appendChild(script);
        }
      });

    loadFileViewer()
      .then((result) => {
        if (result.isSuccess) {
          setFileViewerComponent(() => result.component);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false); // Stop loading if there's an error
      });
  }, []);

  if (loading) {
    return <LoadingOutlined />;
  }

  if (!FileViewerComponent) {
    return <div>Error loading File Viewer Component</div>;
  }

  return <FileViewerComponent {...props} />;
};

export default FileViewer;
